<button type="button" class="btn btn-primary disabled d-flex align-items-center sm-cursor-grab">
  <span i18n>Add PDF</span>
  <span class="cc-icon cc-icon-attachment"></span>
</button>
